import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Land.css";
const Land = () => {
  const ref = useRef(null);
  React.useEffect(() => {
    import("@lottiefiles/lottie-player");
  });

  return (
    <div className="land">
      <Container>
        <Row>
          <Col xs={12} md={6}>
            {" "}
            <div className="land-text" data-aos="fade-right">
              <h1>
                Hello ,I'm <br />
                <span>Mahmoud Ashraf </span>
              </h1>
              <h3> Front-end web developer.</h3>
              <br />

              <h6>
                Being able to build the designs I produce means I can bring your
                idea to life and make it usable in future.
                <br />
                <br />
                <a variant="dark" href="#about" className="start">
                  <Row>
                    {" "}
                    Get Started{" "}
                    <lottie-player
                      id="firstLottie"
                      ref={ref}
                      autoplay
                      loop
                      mode="normal"
                      src="https://assets8.lottiefiles.com/packages/lf20_uzoyW6.json"
                      style={{
                        width: "60px",
                      }}
                    ></lottie-player>
                  </Row>
                </a>{" "}
                <a className="contact-button" variant="outline-dark" href="#footer">
                  <Row>
                    {" "}
                    Contact ME
                    <lottie-player
                      id="firstLottie"
                      ref={ref}
                      autoplay
                      loop
                      mode="normal"
                      src="https://assets8.lottiefiles.com/packages/lf20_uzoyW6.json"
                      style={{
                        width: "60px",
                      }}
                    ></lottie-player>
                  </Row>
                </a>{" "}
              </h6>
            </div>
          </Col>
          <Col xs={12} md={6} className="rightside">
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets3.lottiefiles.com/packages/lf20_ghs9bkkc.json"
            ></lottie-player>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Land;
